import React, { useState } from 'react';

import { CmTableBodyRow, CmTd, CmText } from '@/components/uiParts';
import { ChevronRightIcon } from '@/components/uiParts';
import { PosDataLevel, PosOption } from '@/domain/models/Pos';
import { unique } from '@/lib/util';
import {
  mappingPosDataLevel,
  MappingPosDataLevelLinkedStores,
  MappingPosDataLevelTds,
  PosItemAndHandlePos,
} from '@/services/Pos';

import { EditableArea } from './EditableArea';

interface Props {
  index: number;
  posItem: PosItemAndHandlePos;
  posDataLevel: PosDataLevel;
  posOption?: PosOption;
  handleInputPosCode: (index: number, newPosCode: string) => void;
  handleInputPromotionOneFreePosCode: (
    index: number,
    newPromotionOneFreePosCode: string
  ) => void;
  handleResetPosCode: (index: number) => void;
  handleResetPromotionOneFreePosCode: (index: number) => void;
}

export const PosTableAccordionItem: React.VFC<Props> = ({
  index,
  posItem,
  posDataLevel,
  posOption,
  handleInputPosCode,
  handleInputPromotionOneFreePosCode,
  handleResetPromotionOneFreePosCode,
  handleResetPosCode,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const commaJoin = (
    targetKey: 'auth_store_name' | 'delivery_service_name' | 'brand_name'
  ) => {
    return unique(
      posItem.linked_stores
        .map((LinkedStore) => LinkedStore[targetKey])
        .filter((LinkedStore) => LinkedStore)
    ).join('、');
  };

  const handleExpanded = () => setIsExpanded((prev) => !prev);

  return (
    <>
      <CmTableBodyRow cursor="pointer">
        <CmTd padding="10px" onClick={handleExpanded}>
          {posItem.item_name}
        </CmTd>
        {/* TODO 互換性がないというエラーが出るため、下記`as`のHACK的なやり方で対応をする。typescriptのverv4.3.5であれば解消できる様子なのでその際にasを削除対応をとる */}
        {(
          mappingPosDataLevel[posDataLevel].tds as MappingPosDataLevelTds[]
        ).map((td) => (
          <CmTd padding="10px" key={td} onClick={handleExpanded}>
            {posItem[td]}
          </CmTd>
        ))}

        <EditableArea
          {...{
            index,
            posItem,
            posOption,
            handleInputPosCode,
            handleInputPromotionOneFreePosCode,
            handleResetPromotionOneFreePosCode,
            handleResetPosCode,
          }}
        />
        <CmTd padding="10px" tabIndex={0} onClick={handleExpanded}>
          <ChevronRightIcon
            transition="0.3s"
            transform={isExpanded ? 'rotate(90deg)' : 'none'}
            fontSize="30px"
          />
        </CmTd>
      </CmTableBodyRow>

      {(
        mappingPosDataLevel[posDataLevel]
          .linkedStores as MappingPosDataLevelLinkedStores[]
      ).map(
        (linkedStore) =>
          isExpanded && (
            <CmTableBodyRow key={linkedStore.key}>
              <CmTd padding="10px 10px 10px 40px" colSpan={5}>
                <CmText fontWeight="bold">{linkedStore.label}一覧</CmText>
                <CmText mt="1">{commaJoin(linkedStore.key)}</CmText>
              </CmTd>
            </CmTableBodyRow>
          )
      )}
    </>
  );
};
